import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from '../../context/LanguageContext';
import './ConfirmModal.css';

// 모듈C 공용 커스텀 확인 모달 (변경요약 테이블·경고·담당자 포함)
// 브라우저 alert/confirm 대체. 화면2(승인)·화면3(롤백)에서 재사용.
function ConfirmModal({
  isOpen,
  onCancel,
  onConfirm,
  title,
  message,
  changes = [],        // [{ label, from, to, unit }]
  warning,
  workerName,
  confirmText,
  cancelText,
  type = 'warning',    // 'warning' | 'danger'
}) {
  const { t } = useTranslation();

  // ESC 로 닫기
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e) => { if (e.key === 'Escape') onCancel(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  const handleBackdrop = (e) => {
    if (e.target === e.currentTarget) onCancel();
  };

  return ReactDOM.createPortal(
    <div className="mc-modal-backdrop" onClick={handleBackdrop}>
      <div className="mc-modal">
        <div className="mc-modal-header">
          <div className={`mc-modal-icon ${type}`}>
            <span className="material-symbols-outlined">
              {type === 'danger' ? 'warning' : 'help'}
            </span>
          </div>
          <h3 className="mc-modal-title">{title}</h3>
          <button className="mc-modal-close" onClick={onCancel}>
            <span className="material-symbols-outlined">close</span>
          </button>
        </div>

        <div className="mc-modal-body">
          {message && <p className="mc-modal-message">{message}</p>}

          {changes.length > 0 && (
            <div className="mc-modal-changes">
              <div className="mc-modal-changes-title">{t('pages.modulec.modal.changeSummary', { n: changes.length })}</div>
              <table className="mc-modal-changes-table">
                <thead>
                  <tr>
                    <th>{t('pages.modulec.modal.param')}</th>
                    <th style={{ textAlign: 'right' }}>{t('pages.modulec.modal.current')}</th>
                    <th style={{ textAlign: 'center' }}></th>
                    <th style={{ textAlign: 'right' }}>{t('pages.modulec.modal.recommended')}</th>
                  </tr>
                </thead>
                <tbody>
                  {changes.map((c) => (
                    <tr key={c.labelKey}>
                      <td>{t(c.labelKey)}</td>
                      <td className="mc-modal-from">{c.from}{c.unit && <span>{c.unit}</span>}</td>
                      <td className="mc-modal-arrow"><span className="material-symbols-outlined">east</span></td>
                      <td className="mc-modal-to">{c.to}{c.unit && <span>{c.unit}</span>}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {warning && (
            <div className={`mc-modal-warning ${type}`}>
              <span className="material-symbols-outlined">error</span>
              {warning}
            </div>
          )}

          {workerName && (
            <div className="mc-modal-worker">
              <span className="material-symbols-outlined">badge</span>
              {t('pages.modulec.modal.worker')} <strong>{workerName}</strong>
            </div>
          )}
        </div>

        <div className="mc-modal-footer">
          <button className="mc-modal-btn cancel" onClick={onCancel}>{cancelText}</button>
          <button className={`mc-modal-btn confirm ${type}`} onClick={onConfirm}>{confirmText}</button>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default ConfirmModal;
